<template>
  <div
    data-node-content
    :class="[
      isEmpty(node.error) ? 'text-yellow-800' : 'text-error',
      { '-mt-3': !node?.content?.length },
    ]"
  >
    {{ node.content ?? "" }}
  </div>
</template>
<script setup lang="ts">
import isEmpty from "lodash/isEmpty";

import type { EditorNode } from "@/models/TextEditor";

defineProps<{
  node: EditorNode;
}>();
</script>
